import { Language } from '../constants';
export const MenuVariant = {
  MENU: 'menu',
  SELECTABLE_MENU: 'selectableMenu'
};
export const MenuAnchorOrigin = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
export const MenuColor = {
  MONO_100: 'mono_100',
  MONO_200: 'mono_200'
};
export const MENU_TRANSLATION_KEYS = {
  accessibleCloseLabel: 'component.Menu.accessibleCloseLabel'
};
export const MENU_TRANSLATIONS = {
  [Language.EN]: {
    [MENU_TRANSLATION_KEYS.accessibleCloseLabel]: 'Collapse list'
  },
  [Language.PL]: {
    [MENU_TRANSLATION_KEYS.accessibleCloseLabel]: 'Zwiń listę'
  },
  [Language.CS]: {
    [MENU_TRANSLATION_KEYS.accessibleCloseLabel]: 'Sbalit seznam'
  },
  [Language.SK]: {
    [MENU_TRANSLATION_KEYS.accessibleCloseLabel]: 'Zbaliť zoznam'
  }
};